export default "__VITE_ASSET__6c779359__"